import { takeLatest, all, call, put, select } from 'redux-saga/effects';
import delay from '@redux-saga/delay-p';

import { CKForm } from 'console-kit';

import { Experience } from 'common-entities';

import EmailIntegrationsActions from '../actions';
import EmailIntegrationsApi from '../email-integrations-api';
import { EMAIL_INTEGRATIONS_FORM_ID } from '../../../common/components/Experience/email-integrations/components/email-designer/email-designer';

function* updateEmailTemplateHandler({ payload: { emailTemplate } }) {
  try {
    yield put(CKForm.Actions.validateForm(EMAIL_INTEGRATIONS_FORM_ID));

    const isValid = yield select(CKForm.Selectors.isFormValid, EMAIL_INTEGRATIONS_FORM_ID);
    const formErrors = yield select(CKForm.Selectors.getFormErrors, EMAIL_INTEGRATIONS_FORM_ID);

    if (isValid) {
      const response = yield call(EmailIntegrationsApi.updateEmailTemplate, emailTemplate);
      yield put(EmailIntegrationsActions.updateEmailTemplateSuccess(response));
      yield put(EmailIntegrationsActions.closeEmailTemplateDesigner());
    } else yield put(EmailIntegrationsActions.showValidationMessage(formErrors));
  } catch (error) {
    yield put(EmailIntegrationsActions.updateEmailTemplateFail(error));
  }
}

function* checkEmailTemplateTokensHandler({ payload: { emailTemplate } }) {
  try {
    const experience = yield select(Experience.Selectors.experience);
    const { unknown, known, required } = yield call(
      EmailIntegrationsApi.checkEmailTemplateTokens,
      emailTemplate,
      experience.id
    );
    yield put(
      EmailIntegrationsActions.checkEmailTemplateTokensSuccess({
        unknown,
        known,
        required,
      })
    );
  } catch (error) {
    yield put(EmailIntegrationsActions.checkEmailTemplateTokensFail(error));
  }
}

function* fetchCampaignTokenListHandler() {
  try {
    const experience = yield select(Experience.Selectors.experience);
    const response = yield call(EmailIntegrationsApi.fetchCampaignTokenList, experience.id);
    yield put(EmailIntegrationsActions.setCampaignTokenList(response));
  } catch (error) {
    yield put(EmailIntegrationsActions.getCampaignTokenListFail(error));
  }
}

function* sendPreviewEmailTemplateHandler({ payload: { emailTo, emailTemplate } }) {
  try {
    const experience = yield select(Experience.Selectors.experience);
    yield put(EmailIntegrationsActions.sendingPreviewEmailTemplate());
    const response = yield call(EmailIntegrationsApi.sendPreviewEmailTemplate, emailTo, emailTemplate, experience.id);

    yield all({
      pause:   delay(5000),
      success: put(EmailIntegrationsActions.sendPreviewEmailTemplateSuccess(response)),
    });

    yield put(EmailIntegrationsActions.closeTestEmailMessage());
  } catch (error) {
    yield put(EmailIntegrationsActions.sendPreviewEmailTemplateFail(error));
  }
}

function* openEmailTemplateDesignerHandler() {
  yield put(EmailIntegrationsActions.fetchCampaignTokenList());
}

export default function* emailDesignerSaga() {
  yield all([
    takeLatest(EmailIntegrationsActions.sendPreviewEmailTemplate.getType(), sendPreviewEmailTemplateHandler),
    takeLatest(EmailIntegrationsActions.fetchCampaignTokenList.getType(), fetchCampaignTokenListHandler),
    takeLatest(EmailIntegrationsActions.checkEmailTemplateTokens.getType(), checkEmailTemplateTokensHandler),
    takeLatest(EmailIntegrationsActions.updateEmailTemplate.getType(), updateEmailTemplateHandler),
    takeLatest(EmailIntegrationsActions.openEmailTemplateDesigner.getType(), openEmailTemplateDesignerHandler),
  ]);
}
